import { ethers } from 'ethers';
import evm from '@wormhole-foundation/sdk/evm';
import { RPCS } from '@shared/utils/config/environment';
/**
 * Creates an EVM signer (works for Ethereum, Optimism, etc.)
 * @param rpcUrl The EVM RPC URL
 * @param privateKey The private key as a hex string
 * @param config Optional configuration for the signer
 *
 * @example
 * ```typescript
 *
 * // EVM Example
 * const evmSigner = await getEVMSigner(
 *   'https://your-eth-rpc.com',
 *   'YOUR_PRIVATE_KEY',
 *   {
 *     debug: true,
 *     overrides: {
 *       maxFeePerGas: BigInt(200000),
 *       maxPriorityFeePerGas: BigInt(200000),
 *     }
 *   }
 * );
 */
export async function getEVMSigner(network, privateKey, config) {
  const rpcUrl = RPCS[network];
  const provider = new ethers.providers.JsonRpcProvider(rpcUrl, network);
  const evmSDK = await evm();
  return evmSDK.getSigner(provider, privateKey, {
    debug: true,
    maxGasLimit: config.maxGasLimit,
    overrides: config
  });
}